import { render, staticRenderFns } from "./CartViewItemComponent.vue?vue&type=template&id=a0154bce&"
import script from "./CartViewItemComponent.vue?vue&type=script&lang=ts&"
export * from "./CartViewItemComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports